export default __webpack_public_path__ + "static/media/icon-check.bdee5269.svg";